import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Permisos/permisosEspecificos';
import PermisosCajaChica from './PermisosCajaChica';

const mstp = state => {
    return {...state.permisosEspecificos, permisos: state.login.me.permisos}
};
const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(PermisosCajaChica)